"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import { MessageTemplateMessages } from "@/messages/message-template/message-template.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { MessageTemplateTableRow } from "./row";
import { MESSAGE_TEMPLATE_TABLE_COLUMNS } from "../../constants";

type Props = {
  data: PaginatedResponse<ICustomerTemplate>;
  pagination: Pagination;
  messages: MessageTemplateMessages;
};

export function MessageTemplateTable({ data, pagination, messages }: Props) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const columns = MESSAGE_TEMPLATE_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items.map((template, index) => (
              <MessageTemplateTableRow
                key={template.id}
                index={index}
                template={template}
                messages={messages}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, page) => changePage(page)}
      />
    </>
  );
}
